import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import css from './button.module.css';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Link(
  linkTo: string,
  label: string,
  primary: boolean = false
): FormComponent {
  return ({ ...rest }) => (
    <LinkComponent linkTo={linkTo} label={label} primary={primary} {...rest} />
  );
}

export function LinkComponent({
  linkTo,
  label,
  primary = false,
  icon,
  className,
}: FormComponentProps & {
  linkTo: string;
  label: string;
  primary?: boolean;
  icon?: IconDefinition;
}) {
  const { t } = useTranslation();
  const iconElement = icon ? <FontAwesomeIcon icon={icon} /> : '';

  return (
    <RouterLink
      className={`${css['button']} ${primary ? css['primary'] : ''} ${
        css[className]
      }`}
      to={linkTo}
    >
      {iconElement}
      <span>{t(label)}</span>
    </RouterLink>
  );
}
